/* eslint-disable import/prefer-default-export */
/* eslint-disable quote-props */
// import axios from 'axios';
import {

  GLOBAL_QUOTATION_CREATE_REQUEST,
  GLOBAL_QUOTATION_CREATE_SUCCESS,
  GLOBAL_QUOTATION_CREATE_ERROR,

  GLOBAL_QUOTATION_UPDATE_REQUEST,
  GLOBAL_QUOTATION_UPDATE_SUCCESS,
  GLOBAL_QUOTATION_UPDATE_ERROR,

  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST,
  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS,
  GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR,

  GLOBAL_QUOTATION_RESET_STATE_QUOTATION,

  GLOBAL_QUOTATION_STORE_PACKAGE,
  GLOBAL_QUOTATION_STORE_COVERAGES,
  GLOBAL_QUOTATION_STORE_ASSISTS,
  GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES,
  GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS,
  GLOBAL_QUOTATION_SET_DATA,
} from 'Redux/types/globalQuotationTypes';

import { BACKEND_URL_QUOTATION } from 'Config/routes';
import { CALL_ACTIONS } from 'Redux/middleware';
import { quotationToDto } from './dtos';

export * from './takerActions';
export * from './vehicleActions';
export * from './globalActions';


// ------------------------------------ ------------------------------------ ------------------------------------
const createQuotation = (data) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      GLOBAL_QUOTATION_CREATE_REQUEST,
      GLOBAL_QUOTATION_CREATE_SUCCESS,
      GLOBAL_QUOTATION_CREATE_ERROR,
    ],
    ENDPOINT: BACKEND_URL_QUOTATION,
    METHOD: 'POST',
    DATA: data,
  },
});
export const createNewQuotation = (data) => (dispatch) => dispatch(createQuotation(data));

// ------------------------------------ ------------------------------------ ------------------------------------
const updateQuotationActionCreator = (quotationId, data) => {
  const payload = quotationToDto(data);

  return {
    [CALL_ACTIONS]: {
      TYPES: [
        GLOBAL_QUOTATION_UPDATE_REQUEST,
        GLOBAL_QUOTATION_UPDATE_SUCCESS,
        GLOBAL_QUOTATION_UPDATE_ERROR,
      ],
      ENDPOINT: `${BACKEND_URL_QUOTATION}${quotationId}/`,
      METHOD: 'PUT',
      DATA: payload,
    },
  };
};
export const updateQuotationAction = (quotationId, data) => (dispatch) => dispatch(updateQuotationActionCreator(quotationId, data));

// ------------------------------------ ------------------------------------ ------------------------------------
const generateInsuranceQuotationAction = (quotationId, amount, reGenerate, insuranceCarriersIds) => ({
  [CALL_ACTIONS]: {
    TYPES: [
      GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_REQUEST,
      GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_SUCCESS,
      GLOBAL_QUOTATION_GENERATE_INSURANCE_QUOTATION_ERROR,
    ],
    ENDPOINT: `${BACKEND_URL_QUOTATION}${quotationId}/generate_insurance_quotations/`,
    METHOD: 'POST',
    DATA: { reGenerate, amount, insurance_carriers_ids: insuranceCarriersIds },
  },
});

export const generateInsuranceQuotation = (quotationId, amount, reGenerate = false, insuranceCarriersIds = []) => (dispatch) => dispatch(generateInsuranceQuotationAction(quotationId, amount, reGenerate, insuranceCarriersIds));

// ------------------------------------ ------------------------------------ ------------------------------------
const resetGlobalQuotationQuotationAction = (defaults) => ({
  type: GLOBAL_QUOTATION_RESET_STATE_QUOTATION,
  defaults,
});

export const resetGlobalQuotationQuotation = (defaults = {}) => (dispatch) => dispatch(resetGlobalQuotationQuotationAction(defaults));

// ------------------------------------ ------------------------------------ ------------------------------------
const storePackageAction = (packageToStore) => ({
  type: GLOBAL_QUOTATION_STORE_PACKAGE,
  package: packageToStore,
});
export const storePackage = (packageToStore) => (dispatch) => dispatch(storePackageAction(packageToStore));

const removePackagesByInsuranceCarriersAction = (insuranceCarrierIds) => ({
  type: GLOBAL_QUOTATION_REMOVE_PACKAGES_BY_INSURANCE_CARRIERS,
  insuranceCarrierIds,
});
export const removePackagesByInsuranceCarriers = (insuranceCarrierIds) => (dispatch) => dispatch(removePackagesByInsuranceCarriersAction(insuranceCarrierIds));

// ------------------------------------ ------------------------------------ ------------------------------------
const storeCoveragesAction = (coverages) => ({
  type: GLOBAL_QUOTATION_STORE_COVERAGES,
  coverages,
});

export const storeCoverages = (coverages) => (dispatch) => dispatch(storeCoveragesAction(coverages));

const storeAssistsAction = (assists) => ({
  type: GLOBAL_QUOTATION_STORE_ASSISTS,
  assists,
})

export const storeAssists = (assists) => (dispatch) => dispatch(storeAssistsAction(assists));

const addInactivePackagesAction = (inactivePackages) => ({
  type: GLOBAL_QUOTATION_ADD_INACTIVE_PACKAGES,
  payload: inactivePackages,
})
export const addInactivePackages = (inactivePackages) => (dispatch) => dispatch(addInactivePackagesAction(inactivePackages));

export const setQuotationDataAction = (data) => ({
  type: GLOBAL_QUOTATION_SET_DATA,
  payload: data,
});
export const setQuotationData = (data) => (dispatch) => dispatch(setQuotationDataAction(data));